import styled from 'styled-components';

import { Button } from '@savgroup-front-common/core/atoms/button';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Container = styled('div')`
  position: relative;
  width: 100%;
  padding: ${spacing('lg')};
`;

export const $Button = styled(Button)`
  height: auto;
  font-size: ${spacing('md')};
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;
